module.exports = __webpack_public_path__ + "img/dashboard_blue.7a5b246d.svg";